import ApplicationController from '../application_controller'
import { put } from '@rails/request.js'

class TerminationReasonsController extends ApplicationController {
  toggle (e) {
    const action = e.target.checked ? 'enable' : 'disable'
    const url = `${e.target.dataset.url}/${action}`

    put(url)
  }
}

export default TerminationReasonsController
